import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {BoxRestApiService} from '../http/box-rest-api.service';
import {Utils} from '@astek/utils';
import {ApiBoxResponse} from '../http/api-box-response';

@Injectable()
export class BoxResolver {
  constructor(
    private readonly _boxRestApiService: BoxRestApiService
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<ApiBoxResponse> {
    if(Utils.isNullOrUndefined(route.params['boxId'])) {
      throw new Error('Missing box id');
    }
    return this._boxRestApiService.requestBox(route.params['boxId'] as string);
  }
}
